import React from 'react';
import { ArrowRightIcon, FingersUpIcon } from "../Icon/HmIcons";
import BodyText from "../Typography/texts/BodyText";
import HeadingXSmall from "../Typography/titles/HeadingXSmall";
import styles from './ChallengesBox.module.scss';
const ChallengesBox = ({ title, description, onClick }) => {
    return (React.createElement("button", { type: "button", onClick: onClick, className: styles.button },
        React.createElement(FingersUpIcon, { className: styles.startIcon }),
        React.createElement("div", { className: styles.textContainer },
            React.createElement(HeadingXSmall, { Tag: "span" }, title),
            React.createElement(BodyText, { Tag: "span" }, description)),
        React.createElement(ArrowRightIcon, { size: "small" })));
};
export default ChallengesBox;
//# sourceMappingURL=ChallengesBox.js.map